import React, { useState } from 'react';
import { HiOutlineSpeakerWave } from 'react-icons/hi2';
import { getCurrentSession } from '../siphook/sipService';
import * as S from '../sipstyles/SipClient.style';

const SpeakerModeComponent = () => {
  const [isSpeaker, setIsSpeaker] = useState(false); // true 스피커모드 false 수화기모드

  // 음소거 토글
  const toggleSpeaker = () => {
    const session = getCurrentSession(); // 현재 WebRTC 세션 가져오기
    if (!session) return;
    setIsSpeaker((prev) => {
      const newState = !prev;
      try {
        window.fromWebToAppSpeakerMode(newState);
      } catch {
        // 정의되지 않았거나 호출 실패해도 여기서 잡아서 흰 화면 방지
        alert(`다음 버전(1.1.8v)부터 이용 가능합니다.`);
      }
      return newState;
    });
  };

  return (
    <S.SpeakerButton onClick={toggleSpeaker} $isSpeaker={isSpeaker}>
      <HiOutlineSpeakerWave />
    </S.SpeakerButton>
  );
};

export default SpeakerModeComponent;
